import React from 'react';
import {Switch,FormGroup,FormControlLabel,Typography} from '@material-ui/core/';
import { isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function HasTeamInput(props) {
    const [Value,setValue] = React.useState(parseInt(props.HasTeam)===1?true:false)
    const onchangeHandle=(e)=>{
        setValue(e.target.checked)
        props.onchangeHandle("Lopande",e.target.checked?1:0)
    }
    const [ansvarig, setasvarig ] = React.useState(props.Ansvarig)
    React.useEffect(()=>{
        if(parseInt(props.Ansvarig) !== ansvarig){
            setasvarig(props.Ansvarig)
            if(parseInt(props.InViteFrom)===0){
                props.onchangeHandle("Lopande",0)            
                setValue(false)
            }
        }
    },[props.Ansvarig])
    return (
        <FormGroup row>

            <FormControlLabel
            control={
                <Switch
                checked={Value}
                size='small'
                disabled={isUndefined(props.disabled)?false:props.disabled}
                onChange={onchangeHandle}
                name="Lopande"
                color="primary"
            />
            }
            label={ <Typography variant="body2" sx={{ fontSize: '12px' }}>{
props.HasOutlook === 2?<IntlMessages id="Label.Gsuit.Meet"/>:<IntlMessages id="Label.outlook.teams"/>
            }</Typography>
                }
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '12px' } }}
            />
      </FormGroup>
    );
}

export default HasTeamInput;